// components/ErrorMessage.tsx
import React from 'react';
import { ModernCard } from './ui/ModernCard.tsx';

interface ErrorMessageProps {
  error: string;
  onClose: () => void;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ error, onClose }) => {
  if (!error) return null;
  
  return (
    <ModernCard className="mb-6 p-4 bg-red-50 border-red-200">
      <div className="flex items-center justify-between">
        <p className="text-red-600 font-medium">{error}</p>
        <button 
          onClick={onClose}
          className="text-red-800 hover:text-red-900 font-medium text-sm"
        >
          ✕
        </button>
      </div>
    </ModernCard>
  );
};